import type { CSSProperties } from 'react';

interface Props {
  size?: 'sm' | 'md' | 'lg';
  variant?: 'horizontal' | 'compact' | 'stacked';
  className?: string;
}

// Sheahan Studios wordmark: Fraunces 600, sentence case, finished with a single
// gold full stop — the brand's one piece of personality. The dot is real
// punctuation (it says "handled"), never recoloured, never interactive.
const sizeMap: Record<NonNullable<Props['size']>, string> = {
  sm: '15px',
  md: '19px',
  lg: '28px',
};

const GOLD = '#b8915a';

export default function Wordmark({ size = 'md', variant = 'horizontal', className = '' }: Props) {
  const fontSize = sizeMap[size];

  const base: CSSProperties = {
    fontFamily: 'Fraunces, Georgia, serif',
    fontWeight: 600,
    fontSize,
    letterSpacing: '-0.01em',
    color: 'var(--color-fg)',
    display: 'inline-flex',
    alignItems: 'baseline',
    lineHeight: 1,
  };

  if (variant === 'compact') {
    return (
      <span className={className} style={base}>
        S<span style={{ color: GOLD }}>.</span>
      </span>
    );
  }

  if (variant === 'stacked') {
    return (
      <span
        className={className}
        style={{ ...base, display: 'inline-block', lineHeight: 1.0 }}
      >
        Sheahan
        <br />
        Studios<span style={{ color: GOLD }}>.</span>
      </span>
    );
  }

  return (
    <span className={className} style={base}>
      Sheahan Studios<span style={{ color: GOLD }}>.</span>
    </span>
  );
}
